import { render, staticRenderFns } from "./chateau-fombrauge.vue?vue&type=template&id=738a03bc&scoped=true"
import script from "./chateau-fombrauge.vue?vue&type=script&lang=js"
export * from "./chateau-fombrauge.vue?vue&type=script&lang=js"
import style0 from "./chateau-fombrauge.vue?vue&type=style&index=0&id=738a03bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a03bc",
  null
  
)

export default component.exports